<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172.12 172.12">
  <path
    d="M23.6 94.39c-4.6,0 -8.33,-3.73 -8.33,-8.33 0,-4.6 3.73,-8.33 8.33,-8.33l54.14 0 0 -54.14c0,-4.6 3.73,-8.33 8.33,-8.33 4.6,0 8.33,3.73 8.33,8.33l0 54.14 54.14 0c4.6,0 8.33,3.73 8.33,8.33 0,4.6 -3.73,8.33 -8.33,8.33l-54.14 0 0 54.14c0,4.6 -3.73,8.33 -8.33,8.33 -4.6,0 -8.33,-3.73 -8.33,-8.33l0 -54.14 -54.14 0z"/>
</svg>
